import { gql } from '@apollo/client';
import { AUDIT_LOG_ENTRY_FRAGMENT } from 'data/fragments/auditLog';

/** Mêmes deux axes et même arbitrage sur les voisines que `GET_AUDIT_LOGS` : la ligne arrivant en
 * direct doit se fondre dans la liste déjà en cache, donc porter exactement la même sélection. */
export const AUDIT_LOG_CREATED_SUBSCRIPTION = gql`
    subscription AUDIT_LOG_CREATED(
        $collectionDocumentIds: [String!]
        $collectionNames: [String!]
        $withSameRequestAuditLogs: Boolean!
    ) {
        auditLogCreated(collectionDocumentIds: $collectionDocumentIds, collectionNames: $collectionNames) {
            ...AuditLogEntryFragment
            sameRequestAuditLogs @include(if: $withSameRequestAuditLogs) {
                ...AuditLogEntryFragment
            }
        }
    }
    ${AUDIT_LOG_ENTRY_FRAGMENT}
`;
